import { useState } from "react";
import { api, formatApiError } from "../lib/api";
import { Card } from "./ui/card";
import { Button } from "./ui/button";
import { Loader2, ShieldCheck, RefreshCw, Download } from "lucide-react";
import { toast } from "sonner";

const bandColor = (b) => ({ A: "#10b981", B: "#84cc16", C: "#f59e0b", D: "#f97316", E: "#ef4444" }[(b || "").toUpperCase()] || "#9CA3AF");

export default function CreditsafeCard({ entity, id, data, vat, isAdmin, onEnriched }) {
  const [busy, setBusy] = useState(false);
  const cs = data || null;

  const enrich = async () => {
    setBusy(true);
    try {
      const { data: res } = await api.post(`/${entity}/${id}/creditsafe-enrich`);
      toast.success("Dati Creditsafe scaricati e salvati");
      onEnriched?.(res.creditsafe);
    } catch (e) {
      toast.error(formatApiError(e.response?.data?.detail) || "Errore Creditsafe");
    } finally { setBusy(false); }
  };

  return (
    <Card className="rounded border-border p-5 space-y-3" data-testid="creditsafe-card">
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-2"><ShieldCheck className="h-4 w-4 text-primary" /><h2 className="font-heading font-semibold text-sm">Creditsafe</h2></div>
        {isAdmin && (
          <Button size="sm" variant={cs ? "outline" : "default"} onClick={enrich} disabled={busy || !vat} data-testid="creditsafe-enrich-btn" title={!vat ? "Partita IVA mancante" : ""}>
            {busy ? <Loader2 className="h-3.5 w-3.5 mr-1.5 animate-spin" /> : cs ? <RefreshCw className="h-3.5 w-3.5 mr-1.5" /> : <Download className="h-3.5 w-3.5 mr-1.5" />}
            {cs ? "Aggiorna" : "Scarica dati"}
          </Button>
        )}
      </div>
      {!vat && <p className="text-xs text-muted-foreground">Inserisci la Partita IVA per scaricare i dati Creditsafe.</p>}
      {vat && !cs && <p className="text-xs text-muted-foreground">Nessun dato scaricato.{isAdmin ? ' Premi "Scarica dati".' : ""}</p>}
      {cs && (
        <div className="space-y-2 text-sm" data-testid="creditsafe-data">
          <div className="grid grid-cols-3 gap-2">
            <Metric label="Score" value={cs.score != null ? `${cs.score}/100` : "—"} />
            <Metric label="Fascia rischio" value={cs.risk_band || "—"} color={cs.risk_band ? bandColor(cs.risk_band) : undefined} />
            <Metric label="Fido" value={cs.credit_limit != null ? `${Number(cs.credit_limit).toLocaleString("it-IT")} €` : "—"} />
          </div>
          <Row l="Denominazione" v={cs.name} />
          <Row l="Safe Number" v={cs.safe_number} />
          <Row l="Forma" v={cs.company_type} />
          <Row l="Codice ATECO" v={cs.activity_code} />
          <Row l="Stato" v={cs.status} />
          <Row l="Ultimo bilancio" v={cs.date_latest_accounts ? new Date(cs.date_latest_accounts).toLocaleDateString("it-IT") : ""} />
          {!cs.has_monitoring && <p className="text-[11px] text-amber-500">Score/fido non ancora disponibili dal monitoraggio: riprova tra qualche istante con "Aggiorna".</p>}
          {cs.refreshed_at && <p className="text-[10px] text-muted-foreground pt-1 border-t border-border">Aggiornato il {new Date(cs.refreshed_at).toLocaleString("it-IT")}</p>}
        </div>
      )}
    </Card>
  );
}

function Metric({ label, value, color }) {
  return <div className="rounded border border-border p-2 text-center"><div className="font-heading font-bold text-base" style={color ? { color } : {}}>{value}</div><div className="text-[9px] uppercase tracking-widest text-muted-foreground">{label}</div></div>;
}
function Row({ l, v }) { if (!v) return null; return <div className="flex gap-2 text-xs"><span className="text-muted-foreground w-28 shrink-0">{l}</span><span className="font-medium break-all">{v}</span></div>; }
